import { Card, CardContent, CardHeader, styled } from '@mui/material';
import CreditsAmountSlider from '../../../MyApps/components/CreditsAmountSlider';

export const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  borderRadius: theme.spacing(1),
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  padding: 0,
  '.MuiCardHeader-content': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  '.MuiCardHeader-title': {
    fontWeight: 700,
    fontSize: theme.spacing(2.5),
    lineHeight: theme.spacing(3.5),
  },
  '.MuiCardHeader-subheader': {
    color: '#4b5563',
  },
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: 0,
}));

export const StyledSlider = styled(CreditsAmountSlider)(() => ({}));
